import type { InstantSurvey } from '@api/instant_survey/types';

export const isCalypsoSurvey = (survey?: InstantSurvey | null): boolean => {
  const surveyProvider = survey?.surveySourceOverride || survey?.surveySource || null;

  return surveyProvider?.toLowerCase() === 'calypso';
};
